import { useEffect, useState } from 'react';
import {
  Box,
  Button,
  Grid,

  Typography,

} from "@mui/material";
import VMSheader from './vmsheader';
import './style.css'
import { useNavigate } from "react-router-dom";
import { getAPI, postAPI } from '../network';
import { formatDate } from '../utils';
import { toast } from "react-toastify";
import Modal from '@mui/material/Modal';
import { makeStyles } from '@mui/styles';


const useStyles = makeStyles((theme) => ({
  modal: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    overflow: 'auto',
    // padding: theme.spacing(2), // Use theme spacing for consistency
    '@media (max-width: 600px)': {
      // padding: theme.spacing(1),
    },
  },
  mediaContainer: {
    width: '90%', // Take most of the screen width for better visibility
    maxWidth: '600px', // Prevent it from being too wide on larger screens
    height: 'auto',
    maxHeight: '90vh', // Fit within the viewport on smaller screens
    overflow: 'hidden',
    textAlign: 'center',
    // backgroundColor: theme.palette.background.paper, // Use theme background for consistency
    // borderRadius: theme.shape.borderRadius, // Add rounded corners
    // boxShadow: theme.shadows[5], // Add shadow for better visibility
    '@media (max-width: 600px)': {
      width: '100%', // Utilize full screen width on smaller devices
      maxWidth: '100%',
      height: 'auto',
      maxHeight: '100%',
    },
  },
  media: {
    width: '100%',
    height: 'auto', // Maintain aspect ratio
    objectFit: 'contain', // Ensure the content fits without distortion
    maxHeight: '80vh', // Ensure it fits within the viewport on all screen sizes
    '@media (max-width: 600px)': {
      maxHeight: '70vh', // Adjust for smaller screens
    },
  },
  thumbnail: {
    width: '100px',
    height: '100px',
    objectFit: 'cover', // Ensure the thumbnail content fits properly
    // borderRadius: theme.shape.borderRadius, // Add rounded corners for consistency
    '@media (max-width: 600px)': {
      width: '75px',
      height: '75px',
    },
  },
}));


export default function Induction() {
  const toastObj = { position: toast.POSITION.TOP_RIGHT };
  const bookId = JSON.parse(localStorage.getItem('BookId'));
  const email = localStorage.getItem('email');
  const [checked, setChecked] = useState(false)
  const [documents, setDocuments] = useState([])
  const [currDate, setCurrDate] = useState(new Date(new Date().setFullYear(new Date().getFullYear() + 1)).toJSON())
  const siteId = localStorage.getItem('siteId');
  const navigateTo = useNavigate();
  const classes = useStyles();
  const [open, setOpen] = useState(false);
  const [selectedMedia, setSelectedMedia] = useState(null);


  const handleOpen = (url) => {
    const url2 = `https://docs.google.com/gview?url=${encodeURIComponent(url)}&embedded=true`;
    window.open(url2, '_blank');
  };

  const handleClose = () => {
    setOpen(false);
    setSelectedMedia(null);
  };
  const handleInduction = async () => {

    if (!checked) {
      toast.warning('Confirmation is required', toastObj)
      return;
    }

    const payload = {
      email,
      induction: true,
      inductionExpiry: currDate,
    }
    const data = await postAPI('visitor/book/updateinduction', payload)
    if (!data.data) {
      const data = await postAPI(`/visitor/book/clockout`)
      if (data) {
        localStorage.clear();
        navigateTo(`/`)
      }
    }

    if (data) {
      const visitor = JSON.parse(localStorage.getItem("visitor"));
      if (visitor) {
        navigateTo(`/vms/task_&_Notify`);
      } else {
        navigateTo(`/vms/visit`);
      }
      localStorage.setItem('induction', true);
    }

  }
  const getSiteDocument = async () => {

    let data = await getAPI(`/user/site-specific-induction/vms?siteId=${siteId}&visibilityPortal=${true}`)
    if (data) {
      setDocuments(data)
    }

  }
  const fetchVisitorDetails = async () => {

    const data = await getAPI('/visitor/profile/details')

    if (data) {
      setChecked(data.induction)
      if (data.inductionExpiry) {
        setCurrDate(data.inductionExpiry)
      } else {
        setCurrDate(new Date(new Date().setFullYear(new Date().getFullYear() + 1)).toJSON())
      }
    }

  }
  useEffect(() => {
    getSiteDocument()
    fetchVisitorDetails()
  }, [])
  return (
    <Grid sx={{ width: '100%', display: 'flex', justifyContent: "center", }}>

      <Box sx={{ display: "flex", justifyContent: "center", alignItems: 'center', flexDirection: 'column', width: '90%' }}>

        {/* <div className='fex2'>
            <div><img height='80px' width='80px' src={Logo}></img></div>
            <div>bar</div>
          </div> */}

        <VMSheader />

        <div className="title-font" >Induction</div>

        <Typography component='h6' varient='' className='visit'>Please read below document & Proceed</Typography>


        {
          documents.map((i, index) => (
            <Button variant="outlined" className='buttoRootA' key={index} onClick={() => handleOpen(i?.document)}>
              {i?.title} ( {i?.category} )
            </Button>
          ))
        }


        <Typography component='h6' varient='' className='visit'>Your next Induction due is on {formatDate(currDate)}</Typography>

        <Typography component='h6' varient='' className='confirm'><input type='checkbox' onClick={() => setChecked(!checked)} checked={checked}
        ></input>I confirm I have read and/or have access to above documents</Typography>

        <Button variant="outlined" className='buttoRootA mar' onClick={handleInduction}>
          Proceed
        </Button>

      </Box>
      <div>

        {selectedMedia && (
          <Modal
            open={open}
            onClose={handleClose}
            className={classes.modal}
          >
            <Box className={classes.mediaContainer}>
              {selectedMedia?.type === 'image' ? (
                <img src={selectedMedia} alt="Media" className={classes.media} />
              ) : (
                <embed src={selectedMedia} type="application/pdf" className={classes.media} />
              )}
            </Box>
          </Modal>
        )}
      </div>
    </Grid>
  )
}

